import { atom } from "jotai";

/**
 * @file Atoms that track the state related to the search
 * such as search term and filters.
 */

export const searchQueryAtom = atom("");
